import type { DecoratedProduct } from '~/utils/shop/DecoratedProduct';

export function createDiscountPercentageText(
  decoratedProduct:
    | Pick<DecoratedProduct, 'price' | 'discountPrice' | 'isSale'>
    | undefined
    | null,
  selectedItemsPrice: number
): string | undefined {
  if (
    !decoratedProduct ||
    selectedItemsPrice == 0 ||
    !decoratedProduct.isSale ||
    !decoratedProduct.price ||
    !decoratedProduct.discountPrice
  ) {
    return;
  }

  const defaultProductPricePlusAddons =
    decoratedProduct.price + selectedItemsPrice;
  const discountPricePlusAddons =
    decoratedProduct.discountPrice + selectedItemsPrice;
  const discountPercentage =
    (1 - discountPricePlusAddons / defaultProductPricePlusAddons) * 100;

  if (discountPercentage < 1) {
    return;
  }

  return `-${discountPercentage.toFixed(0)}%`;
}
